import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { IonButton, IonImg, IonLabel, IonRow } from '@ionic/react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import store from '../../store';
import { registerOtp } from '../../api/portal/auth.api';
import { IJwt } from '../../models/portal/auth.model';
import { useToast } from '../../providers/ToastProvider';
import OtpInput from '../otpInput/OtpInput';

interface IComponentProps {
  password: string;
  qrCode: string;
  privateKey: string;
  otpRegisterHandler: () => void;
}

interface IFormInputs {
  otp: string;
}

const schema = yup.object().shape({
  otp: yup.string().required('one-time password is required'),
});

const RegisterOtp: React.FC<IComponentProps> = ({ password, qrCode, privateKey, otpRegisterHandler }) => {
  const [isRegisteringOtp, setIsRegisteringOtp] = useState(false);
  const [useKey, setUseKey] = useState(false);

  const {
    actions: { errorToast },
  } = useToast();

  const { handleSubmit, setValue } = useForm<IFormInputs>({
    defaultValues: {},
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const onSubmit = handleSubmit(async (data) => {
    const { databaseId, displayUsername } = store.getState().auth.token || ({} as IJwt);
    try {
      setIsRegisteringOtp(true);
      await registerOtp(displayUsername, password, databaseId || '0', data.otp);
      otpRegisterHandler();
    } catch (ex: any) {
      errorToast('Failed to configure one-time password');
    } finally {
      setIsRegisteringOtp(false);
    }
  });

  return (
    <>
      {useKey ? (
        <IonLabel className="instruction-label">Enter this code into the authenticator app on your mobile device.</IonLabel>
      ) : (
        <IonLabel className="instruction-label">Scan this QR code with the authenticator app on your mobile device.</IonLabel>
      )}
      {useKey ? <div className="otp-key ion-text-wrap">{privateKey}</div> : <IonImg src={qrCode} alt="QR Code" className="qr-code ion-margin" />}
      <div className="flexed col flexed-center">
        <IonButton color="warning" onClick={() => setUseKey((useKey) => !useKey)}>
          {useKey ? `Prefer to scan the code?` : `Can't scan the code?`}
        </IonButton>
      </div>

      <form id="userForm" noValidate onSubmit={onSubmit}>
        <div className="ion-margin-top">
          <OtpInput theme={'light'} changeCallback={(otp) => setValue('otp', otp)} />
        </div>
        <IonRow>
          <IonButton type="submit" disabled={isRegisteringOtp} className="flexed-fill">
            <span className="label">ENABLE TWO-STEP AUTHENTICATION</span>
          </IonButton>
        </IonRow>
        <button type="submit" className="hidden" />
      </form>
    </>
  );
};

export default RegisterOtp;
